import { GraphApiInnerError, IGraphApiInnerError } from './graphApiInnerError';

export class GraphApiError {
	public static parse(data: IGraphApiError): GraphApiError {
		const error: GraphApiError = new GraphApiError();
		if ((data.code !== undefined) && (data.code != null)) {
			error.code = data.code;
		}
		if ((data.message !== undefined) && (data.message != null)) {
			error.message = data.message;
		}
		if ((data.innerError !== undefined) && (data.innerError != null)) {
			error.innerError = GraphApiInnerError.parse(data.innerError);
		}
		return error;
	}
	public code: string = '';
	public message: string = '';
	public innerError: GraphApiInnerError = new GraphApiInnerError();
}

export interface IGraphApiError {
	code?: string;
	message?: string;
	innerError?: IGraphApiInnerError;
}
